export default {
  Account: {
    Login: 'Đăng nhập',
    Account: 'Tài khoản',
    Password: 'Mật khẩu',
    Register: 'Đăng ký',
    RegisterNow: 'Đăng ký ngay',
    LoginNow: 'Đăng nhập ngay',
    RegisterAccount: 'Đăng ký tài khoản',
    LoginWithFaceBook: 'Đăng nhập với Facebook',
    LoginWithGoogle: 'Đăng nhập với google',
    LoginSuccess: 'Đăng nhập thành công',
    DoYouForgetPassword: 'Bạn quên mật khẩu?',
    DoYouForgetUserNameOrPassword: 'Bạn quên tên đăng nhập, mật khẩu?',
    DoYouNotHaveAccount: 'Bạn chưa có tài khoản?',
    DoYouHaveAccount: 'Đã có tài khoản?',
    AuthenticateInformation: 'Xác thực thông tin',
    ResendCode: 'Gửi lại mã',
    TryAnotherWay: 'Thử cách khác',
    ChooseHowToGetTheCode: 'Chọn cách lấy mã',
    GetFromPhoneNumber: 'Nhận từ số điện thoại',
    GetFromEmail: 'Nhận từ email',
    GetFromAuthenticationApplication: 'Nhập từ ứng dụng xác thực',
    SelectOneOfTheMethodsBelowToReceiveYourLoginVerificationCode: 'Chọn một trong những cách thức bên dưới để nhận mã xác thực đăng nhập',
    DoNotAskAgainOnThisDevice: 'Không hỏi lại trên thiết bị này',
    ChoseLocality: 'Chọn địa bàn',
    ChoseSchool: 'Chọn trường',
    SurnameAndMiddlename: 'Họ và tên đệm',
    UnregisteredMessage: 'Trường của bạn chưa có trên hệ thống, vui lòng để lại thông tin và nhấn gửi yêu cầu để nhân viên tư vấn liên hệ lại',
    Continue: 'Tiếp tục',
    SendRequest: 'Gửi yêu cầu',
    CongratulationsOnYourSuccessfulAccountCreation: 'Chúc mừng bạn đã tạo tài khoản thành công!',
    ComeInNow: 'Vào ngay',
    PleaseEnterTheCodeBelowToConfirmThatItIsNotARobot: 'Vui lòng nhập mã bên dưới để xác nhận không phải là người máy',
    PleaseChooseYourCurrentSchool: 'Bạn vui lòng chọn trường đang công tác',
    InfomationIsNotAllowBlank: 'Thông tin không được để trống',
    SchoolIsNotAllowBlank: 'Thông tin trường không được để trống',
    UpperAndLowerLetter: 'Chữ in hoa, thường',
    HasDigit: 'Có chữ số',
    Digit: 'Số',
    EightCharacters: 'Ít nhất 8 ký tự',
    TryAgainWithEmail: 'Thử lại với email',
    TryAgainWithPhoneNumber: 'Thử lại với số điện thoại',
    HasErrorTryAgain: 'Có lối xảy ra vui lòng thử lại',
    NotEnoughCode: 'Bạn chưa nhập đủ mã',
    ChangePasswordSuccess: 'Thay đổi mật khẩu thành công',
    GoogleAuthen: 'Ứng dụng xác thực',
    EnterVerificationCodeSent: 'Vui lòng nhập mã xác thực được gửi đến',
    YourGoogleAuthen: 'Ứng dụng xác thực của bạn',
    NotReceivedCode: 'Bạn không nhận được mã',
    SendAgain: 'Gửi lại',
    PhoneNumber: 'Số điện thoại',
    Email: 'Email',
    UserName: 'Tên đăng nhập',
    EmailVerification: 'Xác thực qua Email',
    PhoneNumberVerification: 'Xác thực qua số điện thoại',
    AuthenticationApplication: 'Ứng dụng xác thực',
    Birthday: 'Ngày sinh',
    Active: 'Kích hoạt',
    HasErrorToken: 'Có lỗi xảy ra. Vui lòng đăng nhập lại!',

    /// chose student join classroom
    ChoseStudentJoinClassroom: 'Vui lòng chọn học sinh để tạo tài khoản tham gia lớp học.',
    SearchStudent: 'Nhập tên học sinh để tìm kiếm',
    SubtitleSelectedStudent: 'Bổ sung thông tin để đăng ký tài khoản',
    LoginHere: 'Đăng nhập tại đây',
    ClassInactiveMessage: 'Lớp này đã dừng hoạt động',
    Class: 'Lớp',
    DublicateStudentClassroom: '{studentName} đã tham gia lớp học. Vui lòng kiểm tra lại hoặc liên hệ với giáo viên phụ trách',
    DontFoundStudent: 'Không tìm thấy học sinh',
    AppName: 'EMIS Ôn tập',
    HasError: 'Đã có lỗi xảy ra. Vui lòng liên hệ MISA để được hỗ trợ.',
    SeeMore: 'Tham khảo thêm',
    NoteClassCodeStart: 'Lưu ý: Với những học sinh đã có tài khoản, vui lòng đăng nhập và điền mã lớp ',
    NoteClassCodeEnd: ' để tham gia.'
  }
}
